import { render, staticRenderFns } from "./OteGuage.vue?vue&type=template&id=12d55f53"
import script from "./OteGuage.vue?vue&type=script&lang=js"
export * from "./OteGuage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports